export default "__VITE_ASSET__b73d6583__"